<!--
 * @date 2025-05-20 17:55
 * @description 编辑工艺路线
-->
<template>
  <ls-table-layout>
    <template #search>
      <ls-info-form :splitNumber="4">
        <ls-info-item title="加工组织" slot="organizationName" :value="detailData.organizationName"></ls-info-item>
        <ls-info-item title="工艺路线编码" slot="routingCode" :value="detailData.routingCode"></ls-info-item>
        <ls-info-item title="工艺路线名称" slot="routingDesc" :value="detailData.routingDesc"></ls-info-item>
        <ls-info-item title="版本号" slot="version" :value="detailData.version"></ls-info-item>
      </ls-info-form>
    </template>
    <template #table>
      <ls-card class="card-form" ref="formRef">
        <a-tabs v-model="activeCode" @change="onChangeTab">
          <a-tab-pane :key="tabCode.base" tab="基本信息">
            <BaseForm ref="baseFormRef" :detailData="detailData" :editIs="false" />
          </a-tab-pane>
          <a-tab-pane :key="tabCode.process" tab="关联工序">
            <ProcessTable ref="processTableRef" :detailData="detailData" :editIs="false" />
          </a-tab-pane>
          <a-tab-pane :key="tabCode.work" tab="关联工作中心">
            <WorkTable ref="workTableRef" :detailData="detailData" :editIs="false" />
          </a-tab-pane>
          <a-tab-pane :key="tabCode.material" tab="关联物料">
            <MaterialTable ref="materialTableRef" :detailData="detailData" :editIs="false" />
          </a-tab-pane>
        </a-tabs>
      </ls-card>
    </template>
  </ls-table-layout>
</template>

<script>
import BaseForm from './components/base-form.vue';
import MaterialTable from './components/material-table.vue';
import ProcessTable from './components/process-table.vue';
import WorkTable from './components/work-table.vue';
import {
  apiGetStandardProcessList
} from '@/api/mes/basedata/standardProcessNew'
export default {
  name: 'StandardProcessNewEdit',
  components: { WorkTable, ProcessTable, MaterialTable, BaseForm },
  data() {
    this.tabCode = {
      base: 'base',
      process: 'process',
      work: 'work',
      materail: 'materail'
    }
    return {
      btnLoading: false,
      detailData: {},
      activeCode: this.tabCode.base
    }
  },
  mounted() {
    this.getDetailData();
  },
  methods: {
    getDetailData() {
      const id = this.$route.params.id;
      apiGetStandardProcessList({ id }).then(res => {
        if(res.code === 200) {
          this.detailData = res?.rows?.[0] || {};
          console.log(this.detailData)
        }
      })
    },
    onChangeTab() {

    },
    onClosePage() {
      this.$closeTabPage(this.$route.fullPath);
    }
  }
}
</script>

<style lang="less" scoped>
</style>
